import type { SVGProps } from 'react';

const SvgFreeBookPolicy = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <path
      fill={props.color}
      d="M4.29 31.69h26v-1.5h-1a1.79 1.79 0 0 1-1.79-1.78v-1.95a1.79 1.79 0 0 1 1.79-1.78h1a.75.75 0 0 0 .53-.22.77.77 0 0 0 .22-.53L31 .86a.76.76 0 0 0-.75-.75H4.84A3.85 3.85 0 0 0 1 3.94v24.47a3.29 3.29 0 0 0 3.29 3.28m25.21-8.51h-21V1.61h8.33v15.66a.76.76 0 0 0 1.3.51l2.71-2.87 2.67 2.87A.76.76 0 0 0 24 18a.7.7 0 0 0 .27-.06.74.74 0 0 0 .48-.69V1.61h4.72ZM18.28 1.61h5v13.75l-1.94-2.06a.73.73 0 0 0-.54-.24.75.75 0 0 0-.54.24l-2 2.08ZM2.5 3.94a2.34 2.34 0 0 1 2.34-2.33H7v21.57H4.29a3.24 3.24 0 0 0-1.79.53Zm0 22.52a1.79 1.79 0 0 1 1.79-1.78h22.16a3.27 3.27 0 0 0-.53 1.78v1.95a3.27 3.27 0 0 0 .53 1.78H4.29a1.79 1.79 0 0 1-1.79-1.78Z"
      data-name="smart-send-time"
    />
  </svg>
);

export default SvgFreeBookPolicy;
